module.exports = __webpack_public_path__ + "static/media/reverseIcon.0c9b9a90.svg";